define.alias("shared/components/shared/ui/search-box/results", "settings/components/shared/ui/search-box/results");